import { useFormContext } from 'react-hook-form';
import { InputBoxed, Box } from '@creditas-ui/react';
import { pipe } from 'fp-ts/function';
import { useRegisterWithEvents } from '~/hooks';
import { getError } from '~/utils/getError';
import { overrideRegister } from '~/utils/overrideRegister';
import type { JSX } from 'react';
import type { FieldTextSchema } from '~/shared/domain/models';

export type FieldTextProps = {
  data: FieldTextSchema;
};

type Component = (props: FieldTextProps) => JSX.Element;

export const FieldText: Component = ({ data }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const {
    name,
    label = '',
    disabled,
    defaultValue,
    placeholder,
    isPII,
    messages: { helperText, error },
  } = data;
  const { registerWithEvents } = useRegisterWithEvents();

  const errorMessage = getError(errors[name], error);
  const maskRegister = overrideRegister(data);
  const eventsRegister = registerWithEvents(data, isPII);

  const registerField = pipe(register, maskRegister, eventsRegister);

  return (
    <Box>
      <InputBoxed
        error={errorMessage}
        id={name}
        {...registerField(name)}
        label={label}
        disabled={disabled}
        helperText={helperText}
        defaultValue={defaultValue}
        placeholder={placeholder}
      />
    </Box>
  );
};
